let language = {
    ORDERS_TITLE_NO: "Order No",
    ORDERS_TITLE_DATE: "Order Date",
    ORDERS_TITLE_STATUS: "Status",
    ORDERS_TITLE_PRODUCTS: "Products",
    ORDERS_TITLE_RESET: "Reset",
    ORDERS_TITLE_SEARCH: "Search"
}

export { language }